import { faSync } from '@fortawesome/free-solid-svg-icons'
import { TFunction } from 'i18next'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../Authentication/Authorization'
import DialogContext from '../../Authentication/DialogContext'
import DataTable from '../../components/DataTable'
import { EditDialogProps } from '../../components/EditDialog'
import { FormDataControl } from '../../components/FormFields'
import Loading from '../../layout/Loading'
import KeyManagementService from '../../service/KeyManagementService'
import GatewayType from '../GatewayType'

const KeyRotation: GatewayType = () => {
  const { t } = useTranslation()
  const [keyRotation, setKeyRotation] = useState('' as string)
  const [loading, setLoading] = useState(true)
  const { editDialogPropsSetter } = useContext(DialogContext)

  useEffect(() => {
    KeyManagementService.getKeyRotation(setKeyRotation).finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
      },
    ]
  }, [])

  const data = [
    {
      label: t('keys.keyRotation'),
      value: keyRotation,
    },
  ]

  return (
    <Loading isLoading={loading}>
      <DataTable
        keyField='label'
        data={data}
        columns={columns}
        caption={t('keys.keyRotation')}
        captionGridSize={5}
        captionButtons={[
          {
            onClick: () => ChangeKeyRotation(keyRotation, setKeyRotation, t, editDialogPropsSetter),
            text: t('keys.keyRotation'),
            icon: faSync,
            permissions: Authorization.keystore.keys.edit,
          },
        ]}
      />
    </Loading>
  )
}

function ChangeKeyRotation(keyRotation: any, setKeyRotation: React.Dispatch<any>, t: TFunction, editDialogPropsSetter: any) {
  const editDialogProps: EditDialogProps = {
    show: true,
    header: t('keys.changeKeyRotationHeader'),
    onSubmit: KeyManagementService.changeKeyRotation,
    onSubmitExtraArgs: [setKeyRotation, t],
    data: (custom: string[]) => [
      {
        id: 'mode',
        type: 'select',
        options: ['RANDOM', 'UNIQUE', 'FIX'],
        onChange: (e: any, setCustom: React.Dispatch<any>) => setCustom([e.target.value]),
        value: custom[0],
        label: t('type.text'),
        required: true,
      },
      ...getSubClassDefinitions(custom, t),
    ],
    initCustom: [keyRotation],
    labelGridSize: 4,
  }

  editDialogPropsSetter(editDialogProps)
}

function getSubClassDefinitions(custom: string[], t: TFunction): FormDataControl[] {
  if (custom[0] === 'FIX') {
    return [
      {
        id: 'keyId',
        type: 'text',
        label: t('keys.keyId'),
        placeholder: t('keys.keyId'),
        requiredMessage: t('invalidMessage', { label: 'Key ID' }),
        required: true,
      },
    ]
  }
  return []
}

export default KeyRotation
